//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function formFactory() {
    return {
        channelId: '',
        productId: '',
        settleRemark: '',
        otherRemark: '',
        contractFile: '',
    };
}

export default {
    data() {
        return {
            form: formFactory(),
            submitLoading: false,

            modelVisible: false,
            productList: [], // 产品列表
        };
    },
    methods: {
        // 产品列表
        queryProductList() {
            this.$get(`${this.getGetters('indexUrl')}/settle/settProduct/listSelect`, (data) => {
                this.productList = data;
            });
        },
        submit() {
            this.submitLoading = true;

            this.$ajax({
                url: '/bhtong/channel/channelInfo/addChannelProduct',
                type: 'post',
                data: this.form,
                fztype: true,
                callback: (data, res) => {
                    this.cancle();
                    ShowMsg('提交成功', 'success');
                    this.$emit('update');
                },
                complete: () => {
                    this.submitLoading = false;
                },
            });
        },
        cancle() {
            this.$emit('cancle');
            this.close();
        },
        open(dwcode) {
            this.modelVisible = true;
            this.queryProductList();

            this.form = formFactory();
            this.form.channelId = dwcode;
        },
        close() {
            this.modelVisible = false;

            this.$refs.form.reset();
        },
    },
    mounted() {},
};
